import React, {useEffect, useRef, useState} from "react";
import {FlyerPageDto, ItemInMenuDto} from "../../../../dtos";
import styles from './itemInMenuContent.module.scss'
import {
    dispatchEventDataType, EVENT_DATA_TYPE_UPLOAD_FILE_FOR_STORE_TYPE,
    EVENT_DATA_TYPE_UPLOAD_FILE_TYPE
} from "../../../../globals/EventDispatcher";
import {useTypedSelector} from "../../../../hooks/useTypeSelector";
import {Box, Typography} from "@mui/material";

// import {InfoItemMenuIcon} from "./itemInfoIcon/itemInfoIcon";

interface Props {
    item: ItemInMenuDto,
    setOpen: (e: boolean) => void,
}


export const ItemInMenuContent = (props: Props) => {
    const promotionsItemsState = useTypedSelector((state) => state.promotionsAndItems);
    const storeState = useTypedSelector((state) => state.storeForAccount);
    let flyerDetailsState = useTypedSelector((state) => state.flyerDetails);
    let {uploadImagesPopup} = useTypedSelector((state) => state);
    const [isDisabled, setDisabled] = useState<boolean>(false)

    // const [withInfoIcon, setStatusInfoIcon] = useState<boolean>(false);

    useEffect(() => {
        console.log("show '+' menu");
        if(props.item.code === "ArchiveItemsFromStoreFile"){
            setDisabled(true);
            return;
        }
        if (props.item.code === "UploadItemsImagesFiles") {
            const isEmpty = promotionsItemsState.dataFromExcelFileForPromosItems.type === undefined;
            setDisabled(isEmpty);
            return;
        }
        if (flyerDetailsState.flyFstRec.fstCaption === "Published"
            && (props.item.code.indexOf('Upload') !== -1
                || props.item.code.indexOf('Delete') !== -1
            ) && props.item.code.indexOf('Store') === -1) {
            setDisabled(true);
            return;
        }
        if (props.item.code === "UploadPromoImages"
            || props.item.code === "UploadItemImages"
        ) {
            setDisabled(!uploadImagesPopup.processingFinished);
            return;
        }
        if (props.item.code === "DeleteAllFlyerFrames") {
            const deletedSpotsIds: number[] = [];
            flyerDetailsState.flyerPages.forEach((page: FlyerPageDto) => {
                page.flyerPageSpots?.forEach((spot) => {
                    deletedSpotsIds.push(spot.fpsRecId!);
                })
            });
            setDisabled(!Boolean(deletedSpotsIds.length));
            return;
        }
        if (props.item.code === "UploadItemImagesForStoreFile") {
            const isEmpty = !storeState.file;
            setDisabled(isEmpty);
            return;
        }
    }, [promotionsItemsState.dataFromExcelFileForPromosItems, props.item, uploadImagesPopup.processingFinished])

    // const isDisabled = props.item.code === "DownloadEmptyExcelFile" || props.item.code === "ExportPromosItemsToExcel";

    // useEffect(() => {
    //     setStatusInfoIcon(props.item.code === "UploadPromosFile" || props.item.code === "UploadItemsFile" || props.item.code === "UploadPromosItemsFile" || props.item.code === "UploadPromosAndItemsFile")
    // }, [props.item])

    const inputRef: React.LegacyRef<HTMLInputElement> = useRef(null);

    const onClick = () => {
        if (props.item.type === 'file') {
            inputRef.current?.click();
        } else if (props.item.type === 'button') {
            if (props.item.isDownload) {
                const data = {
                    files: [{}],
                    code: props.item.code
                }
                dispatchEventDataType<string | undefined>(props.item.code.indexOf('Store') !== -1
                        ? EVENT_DATA_TYPE_UPLOAD_FILE_FOR_STORE_TYPE
                        : EVENT_DATA_TYPE_UPLOAD_FILE_TYPE,
                    data);
                props.setOpen(false);
            } else {
                const file = props.item.code.indexOf('Store') !== -1 ? storeState.file : promotionsItemsState.dataFromExcelFileForPromosItems;
                const data = {
                    files: [file],
                    code: props.item.code
                }
                dispatchEventDataType<string | undefined>(props.item.code.indexOf('Store') !== -1
                        ? EVENT_DATA_TYPE_UPLOAD_FILE_FOR_STORE_TYPE
                        : EVENT_DATA_TYPE_UPLOAD_FILE_TYPE,
                    data);
                props.setOpen(false);
            }
        }
    }


    const onFileSelected = (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files!;
        const data = {
            files: files,
            code: props.item.code
        }
        dispatchEventDataType<string | undefined>(props.item.code.indexOf('Store') !== -1
                ? EVENT_DATA_TYPE_UPLOAD_FILE_FOR_STORE_TYPE
                : EVENT_DATA_TYPE_UPLOAD_FILE_TYPE,
            data
        );
        props.setOpen(false);
    }


    return (
        <>
            <Box>
                <Box
                    display={`flex`} className={`${styles.item_name} ${isDisabled ? styles.disabled : ''}`}
                    onClick={onClick}>
                    {
                        props.item.icon &&
                        <Box mr={`10px`} display={`flex`} alignItems={'center'}>
                            {props.item.icon}
                        </Box>
                    }

                    <Typography fontSize={`14px`}>{props.item.name}</Typography>

                </Box>
                <input
                    ref={inputRef}

                    // must be hidden
                    hidden

                    type={props.item.type}
                    accept={props.item.filesFormat}

                    multiple={props.item.isMultiply}
                    onClick={() => {
                        //--------------------------------------------------//
                        // BUG FIX: to select the same file multiple times

                        // bug fix: for chrome
                        if (inputRef.current !== null) {
                            inputRef.current!.value = '';
                        }

                        // bug fix: for firefox
                        return false;
                        //--------------------------------------------------//
                    }}
                    onChange={onFileSelected}
                />
            </Box>

            {/*{withInfoIcon && <InfoItemMenuIcon code={props.item.code} text={props.item.text} isDisabled={isDisabled}/>}*/}
        </>
    )
}